import React, { Component } from 'react';
import classnames from 'classnames';
import {Col, Row} from 'react-bootstrap';
import Redux from 'redux';
import _ from 'underscore';

class TwitterWidgetView extends Component {

    componentDidMount() {
        window.twttr && window.twttr.widgets && window.twttr.widgets.load && window.twttr.widgets.load();
    }

    render() {
        var twitterHandle = this.props && this.props.twitterHandle;
        var url = 'https://twitter.com/' + twitterHandle;
        if (!twitterHandle) {
            return <div></div>;
        }
        return <a className="twitter-timeline" href={url}
            data-widget-id="370562862000795648"
            width="520"
            data-chrome="transparent noborders"
            data-link-color="#3cafe4"
            data-height="400"
            data-screen-name={twitterHandle}
            data-show-replies="false"/>;
    }
}

export default TwitterWidgetView;

